import React, { useMemo, useContext } from 'react';
import { IUIUrval } from '../../../../../../Types/UrvalTypes';
import { RutinSettingsContext } from '../../RutinAvailabilityContext/RutinAvailabilityContext';
import { getEmptyUrval } from '../../../../../../Components/Urval/Utils/urvalUtils';

export interface IDetaljurvalContext {
  detaljurval: IUIUrval | null;
  setDetaljurval: (value: IUIUrval | null) => void;
}

interface IProps {
  rutinID: number;
  collectionName: string;
}

export const DetaljurvalContext = React.createContext<IDetaljurvalContext>({
  detaljurval: null,
  setDetaljurval: () => {},
});

export const DetaljurvalContextProvider: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const rutinAvailabilityContext = useContext(RutinSettingsContext);
  const { setDetaljurval } = rutinAvailabilityContext;
  const rutinSettings = rutinAvailabilityContext.settings[props.rutinID];
  const currentUrval = rutinSettings?.detaljurval?.[props.collectionName];
  const value = useMemo<IDetaljurvalContext>(
    () => ({
      detaljurval: currentUrval ?? getEmptyUrval(),
      setDetaljurval: setDetaljurval(props.rutinID, props.collectionName),
    }),
    [currentUrval, setDetaljurval, props.rutinID, props.collectionName]
  );

  return (
    <DetaljurvalContext.Provider value={value}>
      {props.children}
    </DetaljurvalContext.Provider>
  );
};
